import { Component, inject } from '@angular/core';

import { LayoutService } from '@components/layout/layout.service';
import { RouterDataService } from '@services/router-data.service';
import { SlideMenuService } from '@services/slide-menu.service';

@Component({
  selector: 'app-h1-heading-title',
  templateUrl: './h1-heading-title.component.html',
  styleUrls: ['./h1-heading-title.component.scss'],
  standalone: false,
})
export class H1HeadingTitleComponent {
  private slideMenuService = inject(SlideMenuService);
  layoutService = inject(LayoutService);
  routerDataService = inject(RouterDataService);

  slideMenu() {
    this.slideMenuService.slideIn();
  }
}
